import React, { useState, useEffect } from "react";
import "./Auth.css";
import imagen from "../../assets/img/logotipo.png";
import achurado from "../../assets/img/achurado-inferior.png";
import superior from "../../assets/img/achurado-superior.png";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import API_URL from "../../const";
import { Link } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [error, setError] = useState(null);
  const [showErrors, setShowErrors] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [idRol, setIdRol] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    setIsOpenSpinner(true);
    e.preventDefault();
    const requestBody = `email=${encodeURIComponent(
      email,
    )}&contrasenia=${encodeURIComponent(contrasenia)}`;

    try {
      if (!email || !contrasenia) {
        setShowErrors(true);
        setIsOpenSpinner(false);
        return;
      }

      const response = await fetch(`${API_URL}auth.php`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: new URLSearchParams({
          email,
          contrasenia,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        try {
          const jsonError = JSON.parse(errorText);
          const mensajeError =
            jsonError[0]?.error || "Ha ocurrido un error desconocido.";

          if (response.status === 403) {
            setMessage(mensajeError);
          } else if (response.status === 404) {
            setMessage("No se encontró una cuenta con ese correo electrónico.");
          } else if (response.status === 401) {
            setMessage("La contraseña ingresada es incorrecta.");
          } else {
            setMessage(mensajeError);
          }

          setError(mensajeError);
        } catch {
          setMessage("Se ha producido un error inesperado. Intenta más tarde.");
          setError("Error desconocido");
        }
        setIsOpenSpinner(false);
        return;
      }

      const data = await response.json();

      // Validar si el backend envió un error
      if (data?.[0]?.error) {
        const mensajeError = data[0].error;
        setMessage(mensajeError);
        setError(mensajeError);
        setIsOpenSpinner(false);
        return;
      }

      if (Array.isArray(data) && data.length > 0) {
        const user = data[0];

        localStorage.setItem("idRol_fk", user.idRol_fk?.toString() || "");
        localStorage.setItem("nombre", user.nombre?.toString() || "");
        localStorage.setItem("id_usuario", user.id_usuario?.toString() || "");
        localStorage.setItem(
          "id_empresasFk",
          user.id_empresasFk?.toString() || "",
        );
        localStorage.setItem("token", user.token?.toString() || "");

        if (user.idRol_fk == 1) {
          navigate("/configuracion");
        } else {
          navigate("/boletin");
        }

        setIsOpenSpinner(false);
      } else {
        setMessage("Respuesta del servidor vacía o inesperada");
        setError("No se encontraron datos de usuario");
        setIsOpenSpinner(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setMessage("Error de red: " + error.message);
      setError("Error de red: " + error.message);
      setIsOpenSpinner(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setEmail(value);
    } else if (name === "contrasenia") {
      setContrasenia(value);
    }
  };

  return (
    <>
      <React.Fragment>
        <Spinner isOpen={IsOpenSpinner}></Spinner>{" "}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "start",
              justifyContent: "end",
              position: "fixed",
              top: 0,
            }}
          >
            <img src={superior} style={{ width: "30%" }}></img>
          </div>

          <div className="flex h-full absolute top-0 left-0 right-0 items-center justify-center">
            {/* Botón Regresar reubicado en el recuadro superior izquierdo */}
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                zIndex: "30",
                backgroundColor: "#ffffff",
                padding: "8px 12px",
                borderRadius: "5px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                border: "1px solid #e0e0e0",
              }}
            >
              <Link
                to="/"
                className="flex items-center text-gray-700 hover:text-blue-800 transition-colors"
              >
                <box-icon name="arrow-back" color="gray"></box-icon>
                <span className="ml-1 text-sm font-medium">Regresar</span>
              </Link>
            </div>

            <div className="w-full card-login rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0 max-w-[70%] z-10 relative">
              <a href="#" className="flex justify-center items-center pt-4">
                <img className="w-60 h-50" src={imagen} alt="logo" />
              </a>
              <div className="ml-5 mr-5 mb-5">
                <form onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-1 text-gray-500 text-sm font-medium text-left"
                    >
                      {" "}
                      Correo{" "}
                    </label>
                    <input
                      value={email}
                      onChange={handleChange}
                      type="email"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      placeholder="usuario@correo.com"
                    />{" "}
                    {showErrors && email === "" && (
                      <p className="text-red-500 text-xs">
                        {" "}
                        El campo es requerido{" "}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="contrasenia"
                      className="block mb-2 text-gray-500 text-sm font-medium text-left"
                    >
                      {" "}
                      Contraseña{" "}
                    </label>
                    <div className="relative">
                      <input
                        value={contrasenia}
                        onChange={handleChange}
                        type={showPassword ? "text" : "password"}
                        name="contrasenia"
                        id="contrasenia"
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10"
                        placeholder="Contraseña"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                        title={
                          showPassword
                            ? "Ocultar contraseña"
                            : "Mostrar contraseña"
                        }
                      >
                        <box-icon
                          type="solid"
                          name={showPassword ? "show" : "hide"}
                          color="gray"
                        ></box-icon>
                      </button>
                    </div>{" "}
                    {showErrors && contrasenia === "" && (
                      <p className="text-red-500 text-xs">
                        {" "}
                        El campo es requerido{" "}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-start ">
                      <div className=" text-sm">
                        <Link
                          to="/recovery"
                          className="text-sm text-black hover:text-blue-800 group-hover:text-primary py-1 lg:py-2 lg:inline-flex lg:px-0 flex mx-1 lg:mr-0"
                        >
                          {" "}
                          Se me olvido mi contraseña{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                  {error && (
                    <p className="text-red-500 text-sm mt-2 mb-2">{message}</p>
                  )}{" "}
                  <button
                    onClick={handleSubmit}
                    type="submit"
                    className="w-full mt-2 text-white bg-[#494544] hover:bg-[#3a3736] focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    {" "}
                    Iniciar sesión{" "}
                  </button>
                  {/* Opción de registro */}
                  <div className="text-center mt-4">
                    <p className="text-sm text-gray-600">
                      ¿No tienes una cuenta?{" "}
                      <Link
                        to="/registrate"
                        className="text-blue-800 hover:underline font-medium"
                      >
                        Regístrate
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className="bg-white"
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
              position: "fixed",
              bottom: 0,
              left: "0",
              right: "0",
            }}
          >
            <img src={achurado} style={{ width: "30%" }}></img>
            <h6 style={{ fontSize: "12px", color: "#6C757D", margin: "10px" }}>
              {" "}
              Industrial Business Clusters{" "}
            </h6>
            <div style={{ width: "30%" }}></div>
          </div>
        </div>
      </React.Fragment>
    </>
  );
}

export default Login;
